<div class="dialog-header">
  <div class="dialog-title-container">
    <mat-icon class="pause-icon" [h3CustomIcon]="pauseTaskIcon"></mat-icon>
    <span class="subtitle-01 dialog-title">Task Paused</span>
  </div>
</div>

@if ((isLoading$ | async) === false) {
  <span class="information-text body-02"
    >The task timer has been paused. Please click resume to continue your work
    to resume the timer or stop work to end your session.</span
  >

  @if (isDurationVisible) {
    <div class="duration-container">
      <span class="duration-content body-02">
        Task Paused at {{ currentDuration | secondsToTime }}/{{
          targetDuration | secondsToTime
        }}</span
      >
    </div>
  }

  <mat-dialog-actions class="buttons-container">
    <button mat-button color="primary" (click)="stopWork()">
      <span class="label-with-icon"
        ><mat-icon class="material-symbols-outlined"> stop_circle </mat-icon
        >STOP</span
      >
    </button>
    <button mat-button color="primary" mat-dialog-close>
      <span class="label-with-icon"
        ><mat-icon class="material-icons-outlined"> play_arrow </mat-icon
        >RESUME</span
      >
    </button>
  </mat-dialog-actions>
} @else {
  <div class="loading-container">
    <span class="caption">Stopping work...</span>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
